import { AllState } from '../../../../store'
import components, { APPLICATION_FUNCTION_EXTERNAL_ID } from '../../../pages'
import { Function } from '../../../../lib/commons/appFunction'
import React, { useEffect, useState } from 'react'
import ProjectPlanTab from '../../../pages/ProjectPlanTab'
import { connect } from 'react-redux'
import {
  getProjectPlanUuidByWbsItemUuid,
  ProjectPlanDetail,
} from '../../../../lib/functions/projectPlan'
import { ErrorCode } from '../../../../handlers/globalErrorHandler'
import WbsItemApi from '../../../../lib/functions/wbsItem'
import BulkSheet, { BulkSheet as BulkSheetType } from '../../BulkSheet'
import { useWbsItemSelectColumnOptions } from '../../../hooks/useWbsItemSelectColumnOptions'
import {
  ProjectPlanProps,
  ProjectPlanRow,
  ProjectPlanState,
} from '../../../pages/ProjectPlan/projectPlanOptions'

interface OwnProps {
  wbsItemUuid: string
}

interface StateProps {
  functions: Function[]
}

const ProjectPlanTabContainer = (props: OwnProps & StateProps) => {
  const { wbsItemUuid, functions } = props
  const [projectPlanUuid, setProjectPlanUuid] = useState<string | undefined>(
    undefined
  )
  const [projectUuid, setProjectUuid] = useState<string | undefined>(undefined)

  const [bulkSheet, setBulkSheet] =
    useState<
      BulkSheetType<
        ProjectPlanProps,
        ProjectPlanDetail,
        ProjectPlanRow,
        ProjectPlanState
      >
    >()

  const { selectColumnOptions } = useWbsItemSelectColumnOptions({
    projectUuid: projectUuid || '',
  })

  useEffect(() => {
    getProjectPlanUuidByWbsItemUuid(wbsItemUuid).then(fetchedUuid => {
      setProjectPlanUuid(fetchedUuid)
    })
    WbsItemApi.getByUuid(wbsItemUuid).then(wbsItem => {
      setProjectUuid(wbsItem.projectUuid)
    })
  }, [wbsItemUuid])

  useEffect(() => {
    if (!bulkSheet || !selectColumnOptions || !projectUuid) {
      return
    }

    bulkSheet.setContext({
      ...(bulkSheet.context || {}),
      ...selectColumnOptions,
    })
  }, [bulkSheet, selectColumnOptions, projectUuid])

  const component =
    components[APPLICATION_FUNCTION_EXTERNAL_ID.PROJECTPLAN_EDIT]
  const appFunction = functions.find(
    v => v.externalId === APPLICATION_FUNCTION_EXTERNAL_ID.PROJECTPLAN_EDIT
  )
  if (!projectUuid) {
    return <></>
  }
  if (!appFunction) {
    Promise.reject({
      code: ErrorCode.UNAUTHORIZED_SCOPE,
      detail: '',
    })
    return <></>
  }
  return (
    <>
      {/* @ts-ignore */}
      <BulkSheet
        {...component}
        options={new ProjectPlanTab()}
        externalId={appFunction.externalId}
        uuid={appFunction.uuid}
        treeRootUuid={projectPlanUuid}
        projectUuid={projectUuid}
        hideHeader={true}
        setBulkSheet={ctx => setBulkSheet(ctx)}
      />
    </>
  )
}

const mapStateToProps = (state: AllState) => ({
  functions: state.appFunction.functions,
})

export default connect(mapStateToProps)(ProjectPlanTabContainer)
